export default __webpack_public_path__ + "assets/mother_lode.d0ae16bb.png";